<template>
  <Layout>
    <template v-if="this.$route.name == 'edit-poshiq-diet-plan'">
      <PageHeader :title="title" :items="items"></PageHeader>
    </template>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form enctype="multipart/form-data" ref="forum" @submit.prevent="
              this.$route.name == 'add-forum' ? 'Save Data' : 'Update Data'
              ">
              <div class="row">
                <b-form-group class="col-6">
                  <label for="input-4">Html</label>

                  <textarea v-model="form.html" class="form-control" @input="onTextareaEdit" rows="25"
                    style="resize: vertical; font-family: monospace;" disabled></textarea>
                </b-form-group>

                <b-form-group class="col-6">
                  <label for="input-4">Html Preview</label>
                  <div ref="editor" contenteditable="true" @focus="isEditingPreview = true"
                    @blur="isEditingPreview = false" @input="onEdit"
                    style="border:1px solid #ccc;padding:15px;max-height:555px;width:100%;box-sizing:border-box;overflow: auto;">
                  </div>
                </b-form-group>
                <b-button type="submit" variant="primary" class="mr-2" @click.prevent="submitData"><span
                    v-if="this.$route.name == 'add-forum'">Save Data</span>
                  <span v-else>Update Data</span>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import forumMixin from "../../../mixins/ModuleJs/poshiq-diet-plan";
// import Multiselect from "vue-multiselect";
import { required, requiredIf } from "vuelidate/lib/validators";
// import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  mixins: [MixinRequest, forumMixin],
  data() {
    return {
      submitted: false,
      title2: "Edit DIET PLAN",
      items: [
        {
          text: "Back",
          href: "/poshiq-diet-plan",
        },
        {
          text: "Data",
        },
      ],
      editor: ClassicEditor,
    };
  },
  validations: {
    form: {
      country: {
        required: requiredIf(
          (form) =>
            form.geographic_type == "country" ||
            form.geographic_type != "country"
        ),
      },
      city: { required: requiredIf((form) => form.geographic_type == "city") },
      state: {
        required: requiredIf(
          (form) =>
            form.geographic_type == "state" || form.geographic_type == "city"
        ),
      },
      name: { required },
      link_name: { required },
      forum_type: { required },
      partner_id: {
        required: requiredIf((form) => form.forum_type == "partner"),
      },
      forum_visibility: { required },
      privacy_rule: {
        required: requiredIf((form) => form.forum_visibility == "private"),
      },
      rule_type_password: {
        required: requiredIf(
          (form) =>
            form.privacy_rule.includes("password") &&
            form.forum_visibility == "private"
        ),
      },
      html_content: {
        required: requiredIf((form) => form.is_homepage_custom == 1),
      },
      landing_page_html: {
        required: requiredIf((form) => form.show_landing_page == 1),
      },
    },
  },
  components: {
    // ckeditor: CKEditor.component,
    Layout,
    PageHeader,
    // Multiselect,
  },
};
</script>
